import React, { ReactElement, useState } from "react";
import styled from "styled-components";
import responsiveStyling from "lib/responsive";
import { ResponsiveHeader } from "components/ResponsiveHeader";
import AddCredentialTypeInputSelect from "./AddCredentialTypeInputSelect";
import AddCredentialForm from "./AddCredentialForm";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px 16px;
  background: #ffffff;
  ${responsiveStyling({
    ">768": `
      padding: 40px;
      margin: 80px 40px;
      max-width: 985px;
      background: #FFFFFF;
      border: 0.5px solid #292A31;
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
    `,
  })}
`;

export default function AddCredentialHomeContainer(): ReactElement {
  const [selectedCredKeyName, setSelectedCredKeyName] = useState<string | null>(
    null
  );

  return (
    <Container>
      <ResponsiveHeader
        title="Add Credential"
        subtitle="Please fill out the following required fields"
      />
      <AddCredentialTypeInputSelect
        selectedCredKeyName={selectedCredKeyName}
        setSelectedCredKeyName={setSelectedCredKeyName}
      />
      {/* Conditionally render form .. down a level? */}
      {selectedCredKeyName && (
        <AddCredentialForm selectedCredKeyName={selectedCredKeyName} />
      )}
    </Container>
  );
}
